import React from 'react';
import Statistics from './Statistics';

const ExportData = () => {
  return <Statistics tab="export" />;
};

export default ExportData;
